'use client';

import { useEffect, useRef, useState } from 'react';
import { Message } from '@/type/chat';
import MessageBox from './MessageBox';
import { AlfaChatRouteLoading } from '../../MessageBoxLoading';
import EmptyChatMessageInput from '../../SearchInput/EmptyChatMessageInput';
import { useSize } from 'ahooks';
import MessageRequest from '@/components/Message/MessageRequest';
import { useTranslation } from '@/lib/i18n';
import { useRouter } from 'next/navigation';
import { useCreateChat } from '@/hooks/useCreateChat';
import { cn } from '@/lib/utils';

export default function Chat({
  loading,
  messages,
  sendMessage,
  chatId,
  floating = false,
  // messageAppeared,
  // rewrite,
  // fileIds,
  // setFileIds,
  // files,
  // setFiles,
  // focusMode,
  // setFocusMode,
  // optimizationMode,
  // editReport,
  // setOptimizationMode,
  // currentTaskId,
  // onAbort,
  isDrawerOpen = false,
  isShared = false,
  // searchable,
  // strategyType,
  // setStrategyType,
}: {
  messages: Message[];
  sendMessage: (message: string, resumeId?: string, messageId?: string) => void;
  loading: boolean;
  chatId: string;
  // messageAppeared: boolean;
  // rewrite: (messageId: string) => void;
  // fileIds: string[];
  // setFileIds: (fileIds: string[]) => void;
  // files: File[];
  // setFiles: (files: File[]) => void;
  // focusMode: string[];
  // setFocusMode: (mode: string[]) => void;
  // currentTaskId?: string | null;
  // optimizationMode: string;
  // setOptimizationMode: (mode: string) => void;
  // onAbort?: (messageId?: string) => void;
  // editReport: (message: Message) => void;
  isDrawerOpen?: boolean;
  isShared?: boolean;
  // searchable?: boolean;
  // strategyType?: Stratege;
  // setStrategyType?: (strategy?: Stratege) => void;
  floating?: boolean;
}) {
  const { t } = useTranslation();
  const router = useRouter();
  const [dividerWidth, setDividerWidth] = useState(0);
  const { createChat, isCreating } = useCreateChat();
  const dividerRef = useRef<HTMLDivElement | null>(null);
  const messageEnd = useRef<HTMLDivElement | null>(null);
  const autoScrollEnabledRef = useRef(true);
  const prevLoadingRef = useRef(loading);

  const messageRefs = useRef<any>([]);

  const size = useSize(dividerRef.current);

  useEffect(() => {
    const updateDividerWidth = () => {
      if (dividerRef.current) {
        // 使用 setTimeout 确保在 DOM 更新后获取宽度
        setTimeout(() => {
          if (dividerRef.current) {
            const width = dividerRef.current.scrollWidth;
            setDividerWidth(width);
          }
        }, 0);
      }
    };

    // 立即执行一次
    updateDividerWidth();

    // Drawer 状态变化时，等待动画完成后再更新
    if (isDrawerOpen !== undefined) {
      setTimeout(updateDividerWidth, 300); // 300ms 是动画时长
    }

    window.addEventListener('resize', updateDividerWidth);

    return () => {
      window.removeEventListener('resize', updateDividerWidth);
    };
  }, [isDrawerOpen, size?.width]);

  useEffect(() => {
    if (loading && !prevLoadingRef.current) {
      autoScrollEnabledRef.current = true;
    }

    prevLoadingRef.current = loading;
  }, [loading]);

  useEffect(() => {
    if (!loading) {
      return;
    }

    const handleUserWheel = () => {
      autoScrollEnabledRef.current = false;
    };

    document.addEventListener('wheel', handleUserWheel, { passive: true, capture: true });

    return () => {
      document.removeEventListener('wheel', handleUserWheel, { capture: true });
    };
  }, [loading]);

  // const [inViewport] = useInViewport(messageEnd);
  const messageContentKey = messages
    .map((m) => `${m.content}${JSON.stringify(m.thinkStatus)}`)
    .join('');

  useEffect(() => {
    if (loading && autoScrollEnabledRef.current) {
      messageEnd.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages.length, messageContentKey, loading]);

  return (
    <div ref={dividerRef} className={cn('flex flex-col pt-10 pb-30 gap-1', { 'pb-0': floating })}>
      {messages.map((msg, i) => {
        const isLast = i === messages.length - 1;

        return (
          <div
            className="py-4"
            key={`${msg.messageId}_${i}`}
            ref={(el: any) => (messageRefs.current[i] = el)}
          >
            {msg.role === 'user' ? (
              <MessageRequest message={msg} key={msg.messageId} />
            ) : (
              <MessageBox
                key={msg.messageId}
                message={msg}
                messageIndex={i}
                history={messages}
                loading={loading}
                isLast={isLast}
                sendMessage={sendMessage}
                query={''}
                isShared={isShared}
                rewrite={(messageId: string) => {
                  console.log(messageId);
                }}
              />
            )}
          </div>
        );
      })}
      {loading && <AlfaChatRouteLoading />}
      <div ref={messageEnd} className="h-0" />

      {!!messages.length && dividerWidth > 0 && (
        <div
          className="bottom-0 pt-8 pb-4 fixed z-40 rounded-t-2xl bg-linear-to-t from-(--bg-main) from-70% to-transparent transition-all duration-300"
          style={{
            width: dividerWidth,
          }}
        >
          {/* <FloatingButton
            inViewport={inViewport}
            onClick={() => messageEnd.current?.scrollIntoView({ behavior: 'smooth' })}
          /> */}
          {!isShared && !floating && (
            <div className={cn('mx-auto max-w-190')}>
              <EmptyChatMessageInput
                isSmall={true}
                inChat={true}
                isCreating={isCreating}
                loading={loading}
                floating
                sendMessage={async (msg: string) => sendMessage(msg)}
              />
            </div>
          )}
          {/* {isShared && <ChatContinue chatId={chatId} />} */}
        </div>
      )}
    </div>
  );
}
